import { slicedToArray as _slicedToArray, objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.esm.js';
import { cn } from '@costar-ui/cosmos';
import { useEffectOnce } from '@costar-ui/hooks';
import { formatNumber, toInteger } from '@costar-ui/utils';
import React, { useState, useCallback, useMemo } from 'react';
import { hasValue, format, isMore, isLess } from './helper.esm.js';
import Divider from '../divider/divider.esm.js';
import Input from '../field/input/input.esm.js';
import '@costar-ui/icons/csg/IconClose';
import 'react-aria';
import '../button/button.esm.js';
import '../card/card.esm.js';
import '../text/heading.esm.js';
import '../layout/auto-size-root/auto-size-root.esm.js';
import Slot from '../layout/slot/slot.esm.js';

var InputRange = /*#__PURE__*/React.forwardRef(function InputRange(props, ref) {
  var value = props.value,
    _props$messages = props.messages,
    minPlaceholder = _props$messages.minPlaceholder,
    maxPlaceholder = _props$messages.maxPlaceholder,
    testId = props.testId,
    isDisabled = props.isDisabled,
    options = props.options,
    minRequiredValue = props.minRequiredValue,
    maxRequiredValue = props.maxRequiredValue,
    onChange = props.onChange;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    minFocused = _useState2[0],
    setMinFocused = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    maxFocused = _useState4[0],
    setMaxFocused = _useState4[1];
  useEffectOnce(function () {
    //console.log('once...')
    //update only on first display
    var updated = {};
    if (hasValue(value.rawMin) && !hasValue(value.min)) {
      updated = _objectSpread2(_objectSpread2({}, value), {}, {
        min: formatNumber(value.rawMin, options === null || options === void 0 ? void 0 : options.locale, options === null || options === void 0 ? void 0 : options.numberFormattingOptions),
        rawMin: toInteger(value.rawMin),
        minDisplay: format(String(value.rawMin), options)
      });
    }
    if (hasValue(value.rawMax) && !hasValue(value.max)) {
      updated = _objectSpread2(_objectSpread2({}, updated || value), {}, {
        min: formatNumber(value.rawMax, options === null || options === void 0 ? void 0 : options.locale, options === null || options === void 0 ? void 0 : options.numberFormattingOptions),
        rawMax: value.rawMax,
        maxDisplay: format(String(value.rawMax), options)
      });
    }
    if (Object.keys(updated).length && onChange) {
      onChange(updated);
    }
  });
  var onBlurMin = useCallback(function () {
    setMinFocused(false);
  }, []);
  var onFocusMin = useCallback(function () {
    setMinFocused(true);
  }, []);
  var onBlurMax = useCallback(function () {
    setMaxFocused(false);
  }, []);
  var onFocusMax = useCallback(function () {
    setMaxFocused(true);
  }, []);
  var onMinChange = useCallback(function (e) {
    var v = e.target.value;
    //console.log({ min: e.target.value })
    var updated = _objectSpread2(_objectSpread2({}, value), {}, {
      min: formatNumber(v, options === null || options === void 0 ? void 0 : options.locale, options === null || options === void 0 ? void 0 : options.numberFormattingOptions),
      rawMin: toInteger(v),
      minDisplay: format(v, options)
    });
    if (hasValue(minRequiredValue)) {
      if (isMore(v, minRequiredValue)) {
        onChange === null || onChange === void 0 || onChange(updated);
      }
    } else {
      onChange === null || onChange === void 0 || onChange(updated);
    }
  }, [options, value, minRequiredValue, onChange]);
  var onMaxChange = useCallback(function (e) {
    var v = e.target.value;
    //console.log({ max: e.target.value })
    var updated = _objectSpread2(_objectSpread2({}, value), {}, {
      max: formatNumber(v, options === null || options === void 0 ? void 0 : options.locale, options === null || options === void 0 ? void 0 : options.numberFormattingOptions),
      maxDisplay: format(v, options),
      rawMax: toInteger(v)
    });
    if (hasValue(maxRequiredValue)) {
      if (isLess(v, maxRequiredValue)) {
        onChange === null || onChange === void 0 || onChange(updated);
      }
    } else {
      onChange === null || onChange === void 0 || onChange(updated);
    }
  }, [options, value, maxRequiredValue, onChange]);
  var testIds = useMemo(function () {
    var id = testId || 'range-input';
    return {
      min: "".concat(id, "-min"),
      max: "".concat(id, "-max"),
      formField: "".concat(id, "-formfield")
    };
  }, [testId]);
  return /*#__PURE__*/React.createElement(Slot, {
    ref: ref,
    direction: "horizontal"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Input, {
    value: minFocused ? value.min : value.minDisplay,
    placeholder: minPlaceholder,
    onBlur: onBlurMin,
    onFocus: onFocusMin,
    onChange: onMinChange,
    "data-testid": testIds.min,
    className: cn('w-32 border border-action-neutral bg-action-base text-neutral-strong hover:border-hover focus:border-focus', isDisabled ? 'border-disabled bg-action-disabled' : '')
  })), /*#__PURE__*/React.createElement(Slot, {
    alignItems: "center",
    className: "px-1"
  }, /*#__PURE__*/React.createElement(Divider, {
    className: "w-5"
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Input, {
    value: maxFocused ? value.max : value.maxDisplay,
    placeholder: maxPlaceholder,
    onBlur: onBlurMax,
    onFocus: onFocusMax,
    onChange: onMaxChange,
    "data-testid": testIds.max,
    className: cn('w-32 border border-action-neutral bg-action-base text-neutral-strong hover:border-hover focus:border-focus', isDisabled ? 'border-disabled bg-action-disabled' : '')
  })));
});

export { InputRange, InputRange as default };
//# sourceMappingURL=input-range.esm.js.map
